import React from "react";
import { Layers, Wrench, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    code: "S/01",
    title: "FDM Printing",
    desc: "Robust, functional parts in PLA, PETG, ABS, ASA & TPU. Up to 350×350×350mm build volume.",
    Icon: Layers,
    specs: ["0.1–0.4mm layer", "Multiple printers · 24/7", "Up to 350×350×350"],
  },
  {
    code: "S/02",
    title: "Prototyping & Batch",
    desc: "From rapid one-offs to short-run production. We engineer for tolerance, fit and repeatability.",
    Icon: Wrench,
    specs: ["1 → 1,000 units", "DFM review", "Finishing & assembly"],
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-b border-[#2A2A2A] bg-[#0A0A0A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-12 md:mb-16 border-b border-white/10 pb-8">
          <div>
            <p className="overline mb-4">// 02 — Capabilities</p>
            <h2
              className="font-display uppercase leading-[0.9] text-white"
              style={{ fontSize: "clamp(2.5rem, 7vw, 6rem)" }}
              data-testid="services-headline"
            >
              What we <span className="text-[#FF5722]">make</span>.
            </h2>
          </div>
          <p className="hidden md:block font-mono-ui text-xs tracking-[0.25em] text-white/50 max-w-xs text-right">
            Two dedicated production lines. Every job tracked from upload to shipping.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border border-[#2A2A2A]">
          {SERVICES.map(({ code, title, desc, Icon, specs }, i) => (
            <div
              key={code}
              data-testid={`service-card-${i}`}
              className={`invert-card group relative bg-[#0F0F0F] p-8 md:p-12 border-[#2A2A2A] ${
                i < SERVICES.length - 1 ? "md:border-r" : ""
              } ${i < SERVICES.length - 1 ? "border-b md:border-b-0" : ""}`}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono-ui text-[11px] tracking-[0.3em] text-white/50 group-hover:text-black/70 accent-line">
                  {code}
                </span>
                <ArrowUpRight
                  className="icon-stroke text-white/40 group-hover:text-black"
                  size={22}
                />
              </div>
              <Icon
                size={42}
                className="icon-stroke text-[#FF5722] group-hover:text-black mb-8"
                strokeWidth={1.4}
              />
              <h3
                className="font-display uppercase text-white group-hover:text-black mb-4 leading-none"
                style={{ fontSize: "clamp(1.75rem, 3.5vw, 3rem)" }}
              >
                {title}
              </h3>
              <p className="font-body text-white/70 group-hover:text-black/80 max-w-sm mb-8">
                {desc}
              </p>
              <ul className="space-y-2 border-t border-white/10 group-hover:border-black/30 pt-5">
                {specs.map((s) => (
                  <li
                    key={s}
                    className="font-mono-ui text-[11px] tracking-[0.18em] uppercase text-white/60 group-hover:text-black/80 flex items-center gap-3"
                  >
                    <span className="w-2 h-2 bg-[#FF5722] group-hover:bg-black inline-block" />
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
